/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { Switch, Route } from 'react-router-dom';
import { Loader } from '@g17eco/atoms/loader';
import { useAppSelector } from '@reducers/index';
import { AppRoute } from '../AppRoute';
import { getHydratedRoutes } from '@constants/routeComponents';
import { companyTrackerInitiativeRoutes } from './routes';

const routes = getHydratedRoutes(companyTrackerInitiativeRoutes);

export const CompanyTrackerInitiativeRoute = () => {

  const initiativeState = useAppSelector((state) => state.initiative);
  if (!initiativeState.loaded) {
    return <Loader />;
  }

  // All of these must load initiatives
  return (
    <Switch>
      {Object.entries(routes).map(([, route]) => (
        <Route
          key={`route_${route.id}`}
          path={route.path}
          exact={route.exact}
          render={() => <AppRoute route={route} />}
        />
      ))}
    </Switch>
  )
}
